import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';
import type { ReactNode } from 'react';

export type MatchInfo = {
  label: string;
  value: ReactNode;
  updateSection?: {
    action: () => void;
    icon: IconType;
  };
  actionButton?: {
    action: () => void;
    icon: IconType;
  };
  tooltip?: {
    icon: IconType;
    value: string;
  };
};

export enum MatchDrawerInfoUpdateEnum {
  DutyCodeAndFunction = 'dutyCodeAndFunction',
  Qualifications = 'qualifications'
}

export type MatchDrawerInfoUpdateType = `${MatchDrawerInfoUpdateEnum}` | null;
